import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'jafar-cip-request-widget',
  templateUrl: './cip-request-widget.component.html',
  styleUrls: ['./cip-request-widget.component.scss']
})
export class CipRequestWidgetComponent {
  router = inject(Router)

  buttonClicked(){
    this.router.navigateByUrl("opsdashboard/requests")
  }
}
